import { bindAbortListeners } from '@atlaskit/react-ufo/ssr-scripts';

import { WATERFALL_INITIAL_MEASURES } from '@confluence/action-measures/entry-points/WaterfallMeasures.ts';

window?.performance?.mark?.(`${WATERFALL_INITIAL_MEASURES.SSR_BEFORE_SCRIPTS}.start`);

// Runs before the HTML body, it is NOT safe to assume SSR has been successful rendered
// This is why we don't check for `window.__SSR_RENDERED__` here
bindAbortListeners(document, window);

window?.performance?.mark?.(`${WATERFALL_INITIAL_MEASURES.SSR_BEFORE_SCRIPTS}.end`);
